import { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { useParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import LineChart from "./LineChart";
import PulseSurveySectionDetails from "./PulseSurveySectionDetails";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";
import "./PulseSurveyReport.css";

function PulseSurveyReport() {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({});
  const [questionData, setQuestionData] = useState([]);
  const [periodTitle, setPeriodTitle] = useState("");

  const { state } = useContext(AuthContext);

  let { rid } = useParams();

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/pulseQuestionnaireEvaluations/report/${rid}`,
        data: {
          language: state.language,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setData(response.data.sectionData);
      setQuestionData(response.data.questionData);
      setPeriodTitle(response.data.periodTitle);
      setIsLoading(false);
    }
    fetch();
  }, [state.language, rid, state.token]);

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Col>
            <Col className="center mb-3">
              <h1>{periodTitle}</h1>
            </Col>
            <Col>
              <LineChart data={data}></LineChart>
            </Col>
          </Col>
        </Row>
        <Row>
          <Col>
            {questionData.map((item) => (
              <PulseSurveySectionDetails
                key={item.sectionName}
                sectionName={item.sectionName}
                questions={item.questions}
              />
            ))}
          </Col>
        </Row>
      </Container>
    );
  }
}

export default PulseSurveyReport;
